module.exports = __webpack_public_path__ + "static/media/axe-battle.a8466840.svg";